<full-modal-config 
    modalTitle="{{ (editable.id ? l10nKeys.modalHeaderEdit : l10nKeys.modalHeaderNew) | vtranslate }}"
    modalSubTitle="{{ editable.getName() }}"
    (onCancel)="editable.dismiss(true)"
    (onSubmit)="editable.submit()"
    [busy]="editable.isBusy()"
    [errors]="editable.errors"
    [warnings]="editable.warnings"
    [valid]="form.valid"
    [modified]="form.touched && form.dirty"
    class="user-profile-modal"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleGeneral | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleGeneral | vtranslate }}</h3>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="name"
                        [objectType]="objectType"
                        fieldName="name"
                        required
                    >
                        {{ l10nKeys.nameInputLabel | vtranslate }}
                    </label>
                    <input
                        id="name"
                        name="name"
                        class="sel-name"
                        clrInput
                        placeholder="{{ l10nKeys.nameInputPlaceholder | vtranslate }}"
                        required
                        regexPattern="objName"
                        [(ngModel)]="editable.config.name"
                    />
                </avi-input-container>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        for="max_concurrent_sessions" 
                        [objectType]="objectType"
                        fieldName="max_concurrent_sessions"
                    >
                        {{ l10nKeys.maxConcurrentSessionsInputLabel | vtranslate }}
                    </label>
                    <input 
                        id="max_concurrent_sessions"
                        name="max_concurrent_sessions"
                        class="sel-max-concurrent-sessions"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.maxConcurrentSessionsInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        [objectType]="objectType"
                        fieldName="max_concurrent_sessions"
                        [(ngModel)]="editable.config.max_concurrent_sessions"
                    />
                </avi-input-container>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitlePasswordComplexity | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitlePasswordComplexity | vtranslate }}</h3>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="min_length"
                        objectType="ComplexityConstraint"
                        fieldName="min_length"
                    >
                        {{ l10nKeys.minLengthInputLabel | vtranslate }}
                    </label>
                    <input
                        id="min_length"
                        name="min_length"
                        class="sel-min-length"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.minLengthInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ComplexityConstraint"
                        fieldName="min_length"
                        [(ngModel)]="editable.config.complexity_constraint.config.min_length"
                    />
                </avi-input-container>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="min_uppercase"
                        objectType="ComplexityConstraint"
                        fieldName="min_uppercase"
                    >
                        {{ l10nKeys.minUppercaseInputLabel | vtranslate }}
                    </label>
                    <input
                        id="min_uppercase"
                        name="min_uppercase"
                        class="sel-min-uppercase"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.minUppercaseInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ComplexityConstraint"
                        fieldName="min_uppercase"
                        [(ngModel)]="editable.config.complexity_constraint.config.min_uppercase"
                    />
                </avi-input-container>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="min_lowercase"
                        objectType="ComplexityConstraint"
                        fieldName="min_lowercase"
                    >
                        {{ l10nKeys.minLowercaseInputLabel | vtranslate }}
                    </label>
                    <input
                        id="min_lowercase"
                        name="min_lowercase"
                        class="sel-min-lowercase"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.minLowercaseInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ComplexityConstraint"
                        fieldName="min_lowercase"
                        [(ngModel)]="editable.config.complexity_constraint.config.min_lowercase"
                    />
                </avi-input-container>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="min_special"
                        objectType="ComplexityConstraint"
                        fieldName="min_special"
                    >
                        {{ l10nKeys.minSpecialInputLabel | vtranslate }}
                    </label>
                    <input
                        id="min_special"
                        name="min_special"
                        class="sel-min-special"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.minSpecialInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ComplexityConstraint"
                        fieldName="min_special"
                        [(ngModel)]="editable.config.complexity_constraint.config.min_special"
                    />
                </avi-input-container>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="min_numeric"
                        objectType="ComplexityConstraint"
                        fieldName="min_numeric"
                    >
                        {{ l10nKeys.minNumericInputLabel | vtranslate }}
                    </label>
                    <input
                        id="min_numeric"
                        name="min_numeric"
                        class="sel-min-numeric"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.minNumericInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ComplexityConstraint"
                        fieldName="min_numeric"
                        [(ngModel)]="editable.config.complexity_constraint.config.min_numeric"
                    />
                </avi-input-container>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="password_history"
                        objectType="ComplexityConstraint"
                        fieldName="password_history"
                    >
                        {{ l10nKeys.passwordHistoryCountInputLabel | vtranslate }}
                    </label>
                    <input
                        id="password_history"
                        name="password_history"
                        class="sel-password-history"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.passwordHistoryInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ComplexityConstraint"
                        fieldName="password_history"
                        [(ngModel)]="editable.config.complexity_constraint.config.password_history"
                    />
                </avi-input-container>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitlePasswordExpiration | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitlePasswordExpiration | vtranslate }}</h3>
                <avi-input-container helperText="{{ l10nKeys.passwordExpirationDaysHelperText | vtranslate }}">
                    <label 
                        aviLabelWithTooltip
                        for="password_expiration_days"
                        objectType="ExpirationConstraint"
                        fieldName="password_expiration_days"
                    >
                        {{ l10nKeys.passwordExpirationDaysInputLabel | vtranslate }}
                    </label>
                    <input
                        id="password_expiration_days"
                        name="password_expiration_days"
                        class="sel-password-expiration-days"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.passwordExpirationDaysInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="ExpirationConstraint"
                        fieldName="password_expiration_days"
                        [(ngModel)]="editable.config.expiration_constraint.config.password_expiration_days"
                    />
                </avi-input-container>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleAccountLockout | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleAccountLockout | vtranslate }}</h3>
                <avi-input-container>
                    <label 
                        aviLabelWithTooltip
                        for="lockout_max_auth_failures"
                        objectType="LockoutConstraint"
                        fieldName="lockout_max_auth_failures"
                    >
                        {{ l10nKeys.lockoutMaxAuthFailuresInputLabel | vtranslate }}
                    </label>
                    <input
                        id="lockout_max_auth_failures"
                        name="lockout_max_auth_failures"
                        class="sel-lockout-max-auth-failures"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.lockoutMaxAuthFailuresInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="LockoutConstraint"
                        fieldName="lockout_max_auth_failures"
                        [(ngModel)]="editable.config.lockout_constraint.config.lockout_max_auth_failures"
                    />
                </avi-input-container>
                <avi-input-container helperText="{{ l10nKeys.lockoutEvaluationPeriodHelperText | vtranslate }}">
                    <label 
                        aviLabelWithTooltip
                        for="lockout_evaluation_period"
                        objectType="LockoutConstraint"
                        fieldName="lockout_evaluation_period"
                    >
                        {{ l10nKeys.lockoutEvaluationPeriodInputLabel | vtranslate }}
                    </label>
                    <input
                        id="lockout_evaluation_period"
                        name="lockout_evaluation_period"
                        class="sel-lockout-evaluation-period"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.lockoutEvaluationPeriodInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="LockoutConstraint"
                        fieldName="lockout_evaluation_period"
                        [(ngModel)]="editable.config.lockout_constraint.config.lockout_evaluation_period"
                    />
                </avi-input-container>
                <avi-input-container helperText="{{ l10nKeys.lockoutPeriodHelperText | vtranslate }}">
                    <label 
                        aviLabelWithTooltip 
                        for="lockout_period"
                        objectType="LockoutConstraint"
                        fieldName="lockout_period"
                    >
                        {{ l10nKeys.lockoutPeriodInputLabel | vtranslate }}
                    </label>
                    <input 
                        id="lockout_period"
                        name="lockout_period"
                        class="sel-lockout-period"
                        type="number"
                        clrInput
                        placeholder="{{ l10nKeys.lockoutPeriodInputPlaceholder | vtranslate }}"
                        configFieldInputValidation
                        objectType="LockoutConstraint"
                        fieldName="lockout_period"
                        [(ngModel)]="editable.config.lockout_constraint.config.lockout_period"
                    />
                </avi-input-container>
            </div>
        </full-modal-tab-section>
    </form>
</full-modal-config>
